module.exports = __webpack_public_path__ + "static/media/Experiment_COCO_small.c23dd525.mp4";